export enum COUNTRIES {
  S_AMERICA = "SOUTH_AMERICA",
  N_AMERICA = "NORTH_AMERICA",
  N_SEA = "NORTH_SEA",
  SE_ASIA = "SOUTHEAST_ASIA",
  W_AFRICA = "WEST_AFRICA",

  OCEANIA = "OCEANIA",
  SENEGAL = "SENEGAL",
  GULF_MEXICO = "GULF OF MEXICO",
  BRAZIL = "BRAZIL",
  GUYANA = "GUYANA",
}
